import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import request from '../ct-request';

const useOrdersHistory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const customerId = useSelector((state) => state.accounts.user.id);

  useEffect(() => {
    const fetchOrdersHistory = async () => {
      if (customerId) {
        setIsLoading(true);
        const ctOrders = await request({
          uri: 'orders/history?sortBy=createdAt&sortDirection=desc',
          options: {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              customerId,
            },
          },
        });
        if (ctOrders.errors) {
          setError(new Error('invalid call to Orders API'));
        }
        dispatch({ type: 'accounts/updateOrders', payload: ctOrders.results });
        setIsLoading(false);
      }
    };

    if (customerId) {
      fetchOrdersHistory();
    }
  }, [customerId, dispatch]);

  return { isLoading, error };
};

export default useOrdersHistory;
